export interface Disease {
  name: string;
  initialPatientPopulation: number;
  newPatientsPerYear: number;
  therapeuticPrice: number;
  economicCostPerPatient: number;
  developmentCost: number;
  yearsOfLife: number;
  scientificName?: string;
  geneOfInterest?: string;
  description?: string;
  healthcareCostPerPatient?: number;
  companies?: string[];
  citations?: {
    [key: string]: string[];
  };
}

export const SUGGESTED_DISEASES: Disease[] = [
  {
    name: "Huntington's disease",
    initialPatientPopulation: 41000,
    newPatientsPerYear: 1200,
    therapeuticPrice: 2500000,
    economicCostPerPatient: 450000,
    developmentCost: 250000000,
    yearsOfLife: 20,
  },
  {
    name: "Wet AMD",
    initialPatientPopulation: 200000,
    newPatientsPerYear: 20000,
    therapeuticPrice: 850000,
    economicCostPerPatient: 120000,
    developmentCost: 250000000,
    yearsOfLife: 15,
  },
  {
    name: "Multiple myeloma",
    initialPatientPopulation: 35000,
    newPatientsPerYear: 35000,
    therapeuticPrice: 419500,
    economicCostPerPatient: 150000,
    developmentCost: 250000000,
    yearsOfLife: 10,
  },
  {
    name: "Parkinson's disease",
    initialPatientPopulation: 500000,
    newPatientsPerYear: 60000,
    therapeuticPrice: 1500000,
    economicCostPerPatient: 250000,
    developmentCost: 250000000,
    yearsOfLife: 15,
  },
  {
    name: "Amyotrophic lateral sclerosis",
    initialPatientPopulation: 16500,
    newPatientsPerYear: 5000,
    therapeuticPrice: 2100000,
    economicCostPerPatient: 300000,
    developmentCost: 250000000,
    yearsOfLife: 5,
  },
  {
    name: "Retinitis pigmentosa",
    initialPatientPopulation: 100000,
    newPatientsPerYear: 4000,
    therapeuticPrice: 850000,
    economicCostPerPatient: 150000,
    developmentCost: 250000000,
    yearsOfLife: 40,
  },
  {
    name: "Duchenne muscular dystrophy",
    initialPatientPopulation: 15000,
    newPatientsPerYear: 600,
    therapeuticPrice: 2000000,
    economicCostPerPatient: 500000,
    developmentCost: 250000000,
    yearsOfLife: 25,
  },
  {
    name: "Spinal muscular atrophy",
    initialPatientPopulation: 9000,
    newPatientsPerYear: 400,
    therapeuticPrice: 2100000,
    economicCostPerPatient: 600000,
    developmentCost: 250000000,
    yearsOfLife: 30,
  },
];

export interface MarketValueInputs {
  initialPatientPopulation: number;
  newPatientsPerYear: number;
  therapeuticPrice: number;
  economicCostPerPatient: number;
  healthcareCostPerPatient: number;
  // TODO: Determine if we'll want to bring this back. It's not part of the current calculations.
  // yearsOfLife: number;
  projectionYears: number;
  developmentCost: number;
  marketPenetrationRate: number;
  approvalProbability: number;
}

export interface ProjectedFigures {
  year: number;
  revenue: number;
  cumulativeRevenue: number;
  economicImpact: number;
}
